var map = {
	"./icon-csv.png": "56cc",
	"./icon-doc.png": "d7d9",
	"./icon-file.png": "565b",
	"./icon-image.png": "472d",
	"./icon-link.png": "8179",
	"./icon-pdf.png": "d31d",
	"./icon-ppt.png": "a568",
	"./icon-video.png": "181b",
	"./icon-xls.png": "464d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a0e";